import { render, staticRenderFns } from "./MediaPreview.vue?vue&type=template&id=16ecfa57&scoped=true&lang=pug&"
import script from "./MediaPreview.vue?vue&type=script&lang=js&"
export * from "./MediaPreview.vue?vue&type=script&lang=js&"
import style0 from "./MediaPreview.vue?vue&type=style&index=0&id=16ecfa57&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ecfa57",
  null
  
)

/* custom blocks */
import block0 from "./MediaPreview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports